import { PaginatedApiFetcher } from '../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { handlerApiError } from '../../lib/basicRepository';
import { restApi } from '../../services/api';
import { PaginatedResponse } from '../../types/request.types';
import { Invite } from './myNetwork.types';

const PATH = '/invites';

export const findInvites: PaginatedApiFetcher<Invite> = (params, signal) =>
  restApi.get<PaginatedResponse<Invite>>(PATH, params, { signal });

export const myNetworkPageRepository = () => {
  const updateSalesReps = (id: string, salesRepresentativesIds: string[]) =>
    restApi.patch(`${PATH}/${id}`, { salesRepresentativesIds });
  const getSegments = async () => handlerApiError(await restApi.get(`segments/tree`));

  return {
    updateSalesReps,
    getSegments,
  };
};
